import { faPlay } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import video1 from 'src/assets/videos/video1.mp4';
import video2 from 'src/assets/videos/video2.mp4';
import video3 from 'src/assets/videos/video3.mp4';
import video4 from 'src/assets/videos/video4.mp4';
import { cn } from 'src/utils';
import React from 'react';

type Props = {
    preview: string;
    index: number;
    title: string;
};

const VIDEO_SOURCES = [video1, video2, video3, video4, video1, video2, video3, video4, video1, video2, video3, video4];

export default function CameraTile(props: Props) {
    const { index } = props;
    const videoRef = React.useRef<HTMLVideoElement>(null);
    const [hidden, setHidden] = React.useState(false);

    const handleClick = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                void videoRef.current.play();
                setHidden(true);
            } else {
                videoRef.current.pause();
                setHidden(false);
            }
        }
    };

    return (
        <div className="relative w-full overflow-hidden rounded-xl">
            <video
                loop
                muted
                playsInline
                className="aspect-video max-h-full max-w-full"
                ref={videoRef}
                src={VIDEO_SOURCES[index]}
            />
            <button
                className={cn(
                    'group xs:aspect-auto bg-gray-300" absolute top-0 left-0 flex aspect-video h-full w-full cursor-pointer items-center justify-center overflow-hidden rounded-xl bg-gray-200',
                    hidden && 'bg-transparent',
                )}
                onClick={handleClick}
            >
                <FontAwesomeIcon
                    icon={faPlay}
                    aria-hidden="true"
                    focusable="false"
                    className={cn(
                        'absolute scale-200 text-white transition-transform group-hover:scale-250',
                        hidden && 'text-transparent group-hover:text-white',
                    )}
                />
            </button>
        </div>
    );
}
